import { getDictByIds, getTreeDictList } from '@/api/system-dict';
import { arrayToTree } from '@/utils/tree';
import { Select, Spin } from 'antd';
import { FC, useEffect, useState } from 'react';

type DataSourceSelectProps = {
  param?: any;
  value?: any;
  options?: any[];
  allowClear?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onChange?: (e) => void;
};

const DataSourceSelect: FC<DataSourceSelectProps> = ({
  param,
  value,
  options = [],
  allowClear = false,
  disabled = false,
  placeholder = '请选择',
  onChange,
  ...props
}) => {
  const [internalOptions, setOptions] = useState(options);
  const [loading, setLoading] = useState(false);
  // const [loaded, setLoaded] = useState(false); // 数据加载标志
  // const cacheRef = useRef(new Map()); // 缓存不同参数的请求结果
  // const mountedRef = useRef(false);

  // API 请求
  const fetchOptions = async () => {
    if (!param) return

    try {
      setLoading(true)      

      const dicts = await getDictByIds(param)
      if (dicts?.length) {
        // 字典数据源：工程分类和工程专业
        const batch = dicts.map(dict => getTreeDictList({ groupCode: dict.dictCode, templateCode: dict.templateCode, version: dict.version, original: dict.original }))
        // let items = []
        Promise.all(batch).then(res => {
          // console.log('fetchOptions: ', res, batch)
          const items = res.reduce((acc, cur) => {
            if (cur.length) {
              const { tree: treeData } = arrayToTree(cur, { idField: 'dictId', keyField: 'dictCode', pidField: 'parentDictId', needChildField: false })
              acc.push(...treeData.map(i => ({ ...i, label: i.dictName, value: i.dictCode, children: null })))
            }
            return acc
          }, [])
          setOptions(items)
        })
      }
    } catch(error) {
      console.error(error)
    } finally {
      // if(mountedRef.current)
      setLoading(false)
    }
  }

  const handleChange = (v, o) => {
    // console.log('handleChange: ', v, o)
    // const option = internalOptions.find(item => item.dictCode === e)
    onChange(o)
  }

  // 初始化加载逻辑
  useEffect(() => {
    if (value) {
      const dictCode = value.value || value
      const hasValueItem = internalOptions.some(item => item.value === dictCode);
      // console.log('value effect :', value, hasValueItem, internalOptions)
      // 当存在初始值但未匹配时自动加载
      if (value && !hasValueItem) {
        fetchOptions()
      }
    }
  }, [value]);
  
  // 下拉菜单展开处理
  const handleOpen = async open => {
    if (open && internalOptions.length === 0) {
      await fetchOptions();
    }
  };

  return (
    <Select
      options={internalOptions}
      onDropdownVisibleChange={handleOpen}
      optionFilterProp="label"
      notFoundContent={
        loading ? (
          <div style={{ textAlign: 'center' }}>
            <Spin size="small" />
          </div>
        ) : (
          '暂无数据'
        )
      }
      value={value}
      loading={loading}
      allowClear={allowClear}
      disabled={disabled}
      placeholder={placeholder}
      onChange={handleChange}
      onSelect={handleChange}
      {...props}
    />
  );
};

export default DataSourceSelect;